<template>
   <v-container>
    <v-row>
        <v-col
        xs="12"
      >
        <v-card class="elevation-5">
          <SendTrackCodeForm v-if="$store.state.transactions.data.length > 0"/>
          <TransactionDetails
            v-if="$store.state.selectedTransaction"
            :transaction="$store.state.selectedTransaction"
          />
          <ContentDeclaration/>
          <Tickets/>
          <v-card-title>
            Transações
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Ex: 2019-05-03, João da Silva, Meu produto, Boleto, Finalizada, Valor"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <TransactionsFilters/>

          <v-btn @click="$store.dispatch('setContentDeclarationDialog', true)" small>Declaração de conteúdo</v-btn>
          <v-btn @click="$store.dispatch('setTicketsDialog', true)" small>Etiquetas</v-btn>
          
          <div class="text-xs-center">
            <v-pagination @input="changePage" v-model="pagination.page" :length="pages"></v-pagination>
          </div>  
          
          <v-data-table      
            :headers="headers"
            :items="$store.state.transactions.data"
            hide-default-footer
            class="elevation-1"
            dense
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',        
            }"                
          >      
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td class="text-xs-left" md-numeric>{{item.platform_id}}</td>
                  <td class="text-xs-left">{{item.store.name}}</td>
                  <td class="text-xs-left">{{item.subcustomer && item.subcustomer.name}}</td>
                  <td class="text-xs-left">
                    {{item.affiliate_id ? item.affiliate.name : '-'}}
                  </td>
                  <td class="text-xs-left">{{item.store.sale_platform.name}}</td>
                  <td class="text-xs-left">{{item.status.name}}</td>
                  <td class="text-xs-left">{{item.payment.name}}</td>
                  <td class="text-xs-left">
                    {{item.finish_date && formatDate(item.finish_date) || '-'}}
                    <br/>
                    {{formatDate(item.start_date)}}
                  </td>
                  <td class="text-xs-left">
                    <span v-for="c in item.comissions" :key="c.id">                
                      <v-chip class="caption">
                        {{c.name}} - R$ {{parseFloat(c.amount).toFixed(2)}}
                      </v-chip>                
                    </span>
                  </td>
                  <td class="text-xs-left"> R$ {{item.amount.replace('.', ',')}}</td>
                  <td class="text-xs-left">
                    <v-btn :disabled="item.subcustomer && !item.subcustomer.address" @click="() => setTrackCodeDialog(item)" fab small color="primary">
                      <v-icon>mail</v-icon>
                    </v-btn>
                    <v-btn fab small color="secondary" @click="() => setDetailsDialog(item)">
                      <v-icon>search</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>    
          <div class="text-xs-center pt-2">
            <v-pagination @input="changePage" v-model="pagination.page" :length="pages"></v-pagination>
          </div>  
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>  
  import moment from 'moment';
  import TransactionsFilters from './TransactionsFilters';
  import SendTrackCodeForm from './SendTrackCodeForm';
  import TransactionDetails from './TransactionDetails';
  import ContentDeclaration from './ContentDeclaration';
  import Tickets from './Tickets';

  export default {
    name: 'Transactions',
    components: {
      TransactionsFilters,
      SendTrackCodeForm,
      TransactionDetails,
      ContentDeclaration,
      Tickets
    },
    created () {      
      this.fetchTransactions();
    },
    computed: {
      pages () {
        if (this.$store.state.transactions.total === 0) {
          return 0;
        }
        return Math.ceil(this.$store.state.transactions.total / this.$store.state.transactions.per_page)
      }
    },
    methods: {
      formatDate (date) {
        return moment(new Date(date)).format('DD/MM/YYYY')
      },
      fetchTransactions() {        
        this.$store.dispatch('fetchTransactions');
      },
      setTrackCodeDialog (data) {        
        this.$store.dispatch('setTrackCodeDialog', {data});
      },
      setDetailsDialog (data) {        
        this.$store.dispatch('setDetailsDialog', {data});
      },
      changePage(page) {
        this.$store.dispatch('setTransactionsPage', page);
        this.fetchTransactions();
      }
    },
    watch: {
      // call again the method if the route changes
      '$route': 'fetchTransactions',
      'search'(newVal, oldVal) {
        if (this.search_timeout) {
            clearTimeout(this.search_timeout);
        }
        const self = this;
        this.search_timeout = setTimeout( () => { 
          this.$store.dispatch('setTransactionsQuery', newVal);
          this.fetchTransactions();
        }, 600);
      }
    },
    data () {
      return {
        search: '',
        search_timeout: null,
        headers: [
          {text: 'Cód..', value: 'platform_id'},
          {text: 'Prod.', value: 'store.name'},
          {text: 'Compr.', value: 'subcustomer.name'},
          {text: 'Afil.', value: 'affiliate.name'},
          {text: 'Plataf.', value: 'pay_way'},
          {text: 'Status', value: 'status'},
          {text: 'Forma Pag.', value: 'pay_type'},
          {text: 'Data', value: 'finish_date'},
          {text: 'Comissão', value: 'comissions'},
          {text: 'Total', value: 'amount'},
          {text: '', value: ''},
        ],
        pagination: {
          descending: false,
          page: this.$store.state.transactions.current_page,
          rowsPerPage: this.$store.state.transactions.per_page,
          sortBy: '',
          totalItems: this.$store.state.transactions.total
        }
      }
    },
  }
</script>
<style lang="css" scoped>
.caption {
  margin-bottom: 2px;
}
</style>